import { type ReactNode } from 'react'

/** The uppercase file-extension chip shared by the card and dialog fallbacks. */
export const ExtensionBadge = ({ children }: { children: ReactNode }) => (
  <span className="rounded-xs bg-paper-elevation4 px-1.5 py-0.5 text-xs font-semibold uppercase tracking-[0.06em] text-text-secondary">
    {children}
  </span>
)
